module.exports = __webpack_public_path__ + "static/media/profile-photo.3bd49af4.svg";